var EqState = {
  GOOD: 0,
  AVERAGE: 1,
  BAD: 2,
};

module.exports = EqState;
